import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getActiveTextConciergeMerchants = {
  name: "getActiveTextConciergeMerchants" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
    sortKey: z.enum(["teamName"]).default("teamName"),
    sortDirection: createEnum(SortDirection).default(SortDirection.ASC),
    searchQuery: z.string().optional(),
  }),
  output: z.object({
    merchants: z.array(
      z.object({
        teamId: z.string(),
        teamName: z.string(),
        recoverEnabled: z.boolean(),
        analyticsSource: z.enum(["v1_snowflake", "v2_opensearch"]),
      }),
    ),
    totalCount: z.number(),
  }),
};
